import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import type { RelayState } from '../api/types';
import { RELAY_STEPS } from '../pages/overview/model';
import { vt } from '../theme';

const useStyles = makeStyles({
  list: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    columnGap: '8px',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  step: { display: 'flex', flexDirection: 'column', rowGap: '10px', fontSize: '11px', color: vt.fg4 },
  bar: { height: '3px', borderRadius: '1.5px', backgroundColor: vt.surface2 },
  current: { color: vt.fg1, fontWeight: tokens.fontWeightSemibold },
  // Running is green and the moving states cyan, as everywhere else; stopped is the neutral ink.
  running: { backgroundColor: vt.green },
  moving: { backgroundColor: vt.cyan },
  stopped: { backgroundColor: vt.fg3 },
});

/**
 * The relay's four states in order, the current one filled: a status word alone never tells
 * you which way the thing is heading.
 */
export function RelayStateMachine({ state }: { state: RelayState }) {
  const s = useStyles();
  const fill = state === 'running' ? s.running : state === 'stopped' ? s.stopped : s.moving;
  return (
    <ol className={s.list} aria-label="Relay state">
      {RELAY_STEPS.map((step) => {
        const on = step === state;
        return (
          <li key={step} className={mergeClasses(s.step, on && s.current)} aria-current={on ? 'step' : undefined}>
            <span className={mergeClasses(s.bar, on && fill)} aria-hidden />
            {step}
          </li>
        );
      })}
    </ol>
  );
}
